import { Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";

const CustomerAndUser = ({ value }) => {
  const [customer, setCustomer] = useState();
  const [user, setUser] = useState();

  useEffect(() => {
    setCustomer(value.customer);
    setUser(value.servedUser);

    return () => {};
  }, [value]);

  const handleViewCustomer = () => {
    window.open(
      `${window.location.origin}/view_customer/${customer.id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleViewUser = () => {
    window.open(
      `${window.location.origin}/user_form/${user.id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="flex gap-[20px] flex-wrap p-[20px]">
      {customer && customer.id ? (
        <div>
          <span className="uppercase text-[12px] font-bold text-gray-500 tracking-widest ml-[20px]">
            Customer
          </span>
          <div
            onClick={handleViewCustomer}
            className="flex gap-[15px] items-center shadow-sm border p-[7px] rounded-[40px] pr-[30px] cursor-pointer hover:!border-primary transition hover:bg-slate-100"
          >
            <Avatar
              className="bg-primary !w-[50px] !h-[50px]"
              src={customer.photo || ""}
            >
              {(customer.firstName + customer.lastName).substring(0, 2)}
            </Avatar>
            <div className="grid">
              <span className="text-[18px] font-medium text-gray-500">
                {customer.firstName + " " + customer.lastName}
              </span>
              <div className="flex gap-1 items-center">
                <span className="fs-12">{customer.cstmrCode}</span>
                {customer.email && (
                  <>
                    | <span className="fs-12">{customer.email}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {user && user.id ? (
        <div>
          <span className="uppercase text-[12px] font-bold text-gray-500 tracking-widest ml-[20px]">
            Served User
          </span>
          <div
            onClick={handleViewUser}
            className="flex gap-[15px] items-center shadow-sm border p-[7px] rounded-[40px] pr-[30px] cursor-pointer hover:!border-primary transition hover:bg-slate-100"
          >
            <Avatar
              className="bg-primary !w-[50px] !h-[50px]"
              src={user.photo || ""}
            >
              {(user?.fullName).substring(0, 2)}
            </Avatar>
            <div className="d-grid">
              <span className="text-[18px] font-medium text-gray-500">
                {user?.fullName}
              </span>
              {user.outlet && (
                <span className="fs-12">{value.outlet.outletName}</span>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomerAndUser;
